/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface HoldingCopy {
  headerUpdatesLabel: string;
  tabs: {
    personal: string;
    isa: string;
    entity: string;
    accountsLabel: string;
    addAccount: (args: { canOpenIsa: string | number }) => string;
    addAccountShort: string;
  };
  accountsTray: {
    title: string;
    subtitle: string;
    isaTitle: string;
    isaSubtitle: string;
    businessTitle: string;
    businessSubtitle: string;
  };
  bankConfirm: {
    title: string;
    body: (args: { dealName: string | number }) => string;
    use: string;
    chooseOther: string;
    accountMask: (args: { lastFour: string | number }) => string;
    accountMaskUnknown: string;
  };
  bankFields: {
    title: string;
    body: (args: { currency: string | number }) => string;
    payoutTitle: (args: { name: string | number; currency: string | number }) => string;
    action: string;
  };
  position: {
    currentValue: string;
    earnedToDate: string;
    profit: string;
    loss: string;
    blendedRate: string;
    ctaAddMoney: string;
    ctaWithdraw: string;
    ctaChangeNotice: string;
    ctaMove: string;
    manageEarnings: string;
    earningsRow: (args: { decision: string | number }) => string;
    earningsRowUndecided: string;
  };
  stat: {
    withdrawalRate: string;
    risk: string;
    nextPayment: string;
  };
  activity: {
    heading: string;
    inProgressHeading: string;
    timelineHeading: string;
    actionNeeded: string;
    today: (args: { date: string | number }) => string;
    empty: string;
    error: string;
    retry: string;
  };
  card: {
    bankTitle: string;
    bankBody: string;
    paymentDueTitle: string;
    paymentDueBody: string;
    pendingWithdrawalTitle: string;
    pendingWithdrawalSubtitle: (args: { sentDate: string | number }) => string;
    pendingLiquidationTitle: string;
    pendingLiquidationSubtitle: (args: { sentDate: string | number }) => string;
    earningsDeadlineTitle: string;
    earningsDeadlineBody: string;
    upcomingEarningsTitle: string;
    upcomingEarningsSubtitle: (args: { dueDate: string | number }) => string;
    upcomingEarningsSubtitleNoDate: string;
    topUpTitle: string;
  };
  earningsCard: {
    title: (args: { month: string | number }) => string;
    titleUpcoming: string;
    cadence: (args: { months: string | number }) => string;
    netLabel: string;
    grossLabel: string;
    projectedLabel: string;
    covers: (args: { range: string | number }) => string;
    nextPayout: (args: { date: string | number }) => string;
  };
  decision: {
    badge: (args: { decision: string | number }) => string;
    line: (args: { decision: string | number }) => string;
    heading: (args: { decision: string | number }) => string;
    body: (args: { decision: string | number; month: string | number }) => string;
    bodyNoMonth: (args: { decision: string | number }) => string;
    footer: (args: { decision: string | number }) => string;
    undecidedBadge: string;
    undecidedLine: string;
    undecidedHeading: string;
    undecidedBody: (args: { month: string | number }) => string;
    undecidedBodyNoMonth: string;
    change: string;
    changeMind: string;
    choose: string;
  };
  info: {
    currentValueTitle: string;
    currentValueBody: string;
    blendedRateTitle: string;
    blendedRateBody: string;
  };
  breakdown: {
    title: string;
    currentValue: string;
    assetValue: string;
    reserved: string;
    withdrawals: string;
    performanceHeading: string;
    profitLoss: string;
    totalEarnings: string;
    contributionsHeading: string;
    confirmedPayments: string;
    firstPayment: string;
    glossaryCta: string;
  };
  glossary: {
    title: string;
    errorTitle: string;
    errorBody: string;
  };
  detail: {
    paymentTitle: (args: { status: string | number }) => string;
    investmentTitle: string;
    investmentStatus: string;
    noteInvested: string;
    withdrawalTitle: string;
    liquidationTitle: string;
    transitionTitle: (args: { kind: string | number }) => string;
    rateToLabel: string;
    rowAmount: string;
    rowAmountDue: string;
    rowAmountPaid: string;
    rowRequestedAmount: string;
    rowConfirmedAmount: string;
    rowFees: string;
    rowNetAmount: string;
    rowInvested: string;
    rowNetInvested: string;
    rowDeal: string;
    rowDue: string;
    rowAcknowledged: string;
    rowReceived: string;
    rowPaidOut: string;
    rowRequested: string;
    rowSettled: string;
    rowCancelled: string;
    rowStartsEarning: string;
    rowEarningRate: string;
    rowRateNow: string;
    rowRateAfter: string;
    rowRateInNotice: string;
    rowNoticeTerm: string;
    rowNoticeEnds: string;
    status: (args: { status: string | number }) => string;
    transitionStatus: (args: { status: string | number }) => string;
    notePaymentDue: string;
    noteInNotice: string;
    error: string;
    makePayment: string;
    viewBankDetails: string;
    cancelPayment: string;
    cancelTransition: (args: { kind: string | number }) => string;
    reallocationTitle: string;
    reallocationStatus: (args: { status: string | number }) => string;
    rowFrom: string;
    rowTo: string;
    rowArrived: string;
    distributionHeading: string;
    distributionTotal: string;
    rowCovers: string;
    rowPaidOn: string;
    rowDecision: string;
    breakdownHeading: string;
  };
  cancelTransitionSheet: {
    title: string;
    body: string;
    keep: string;
    cancelled: string;
    failed: string;
  };
  cancelPaymentSheet: {
    title: string;
    body: string;
    keep: string;
    failed: string;
  };
  compare: {
    transitionHeading: string;
    reallocationHeading: string;
    now: string;
    after: string;
    from: string;
    to: string;
    lineNotice: string;
    lineMonths: (args: { months: number }) => string;
    lineNoNotice: string;
    lineNoticeUndecided: string;
    lineRate: string;
    lineSent: string;
    lineArrives: string;
    lineMember: string;
    delta: (args: { points: string | number }) => string;
    noticeBanner: (args: { rate: string | number }) => string;
    noticeBannerUntil: (args: { rate: string | number; until: string | number }) => string;
    exitBanner: (args: { rate: string | number }) => string;
  };
  blended: {
    title: string;
    body: string;
    depositsHeading: string;
    inNotice: string;
    rowBase: string;
    rowBoost: string;
    rowMember: string;
    rowAdjustment: string;
    legend: (args: { principal: string | number; rate: string | number }) => string;
    depositedOn: (args: { date: string | number }) => string;
    guaranteed: (args: { rate: string | number; date: string | number }) => string;
  };
  documents: {
    rowTitle: string;
    rowSubtitle: string;
    eisRowTitle: (args: { count: string | number }) => string;
    eisRowSubtitle: string;
    title: string;
    statementTitle: string;
    statementBody: string;
    dealDocumentsHeading: string;
    dealDocumentsEmpty: string;
  };
  liquidationDestination: {
    heading: string;
    paidOut: (args: { account: string | number }) => string;
    paidOutDefault: string;
    movedTo: (args: { deal: string | number }) => string;
    movedToIsa: (args: { deal: string | number }) => string;
    change: string;
    title: string;
    intro: string;
    withdrawTitle: string;
    withdrawTo: (args: { account: string | number }) => string;
    withdrawToDefault: string;
    changeAccount: string;
    dealsHeading: string;
    dealLine: (args: { months: number }) => string;
    dealLineWithRate: (args: { rate: string | number; months: number }) => string;
    agreement: (args: { deal: string | number }) => string;
    save: string;
    saveError: string;
    noAccount: string;
    addAccount: string;
    withdrawNoAccount: string;
    cancel: string;
  };
}

export const holdingSchema: NamespaceSchema = {
  namespace: "holding",
  keys: {
    "headerUpdatesLabel": [],
    "tabs.personal": [],
    "tabs.isa": [],
    "tabs.entity": [],
    "tabs.accountsLabel": [],
    "tabs.addAccount": ["canOpenIsa"],
    "tabs.addAccountShort": [],
    "accountsTray.title": [],
    "accountsTray.subtitle": [],
    "accountsTray.isaTitle": [],
    "accountsTray.isaSubtitle": [],
    "accountsTray.businessTitle": [],
    "accountsTray.businessSubtitle": [],
    "bankConfirm.title": [],
    "bankConfirm.body": ["dealName"],
    "bankConfirm.use": [],
    "bankConfirm.chooseOther": [],
    "bankConfirm.accountMask": ["lastFour"],
    "bankConfirm.accountMaskUnknown": [],
    "bankFields.title": [],
    "bankFields.body": ["currency"],
    "bankFields.payoutTitle": ["name", "currency"],
    "bankFields.action": [],
    "position.currentValue": [],
    "position.earnedToDate": [],
    "position.profit": [],
    "position.loss": [],
    "position.blendedRate": [],
    "position.ctaAddMoney": [],
    "position.ctaWithdraw": [],
    "position.ctaChangeNotice": [],
    "position.ctaMove": [],
    "position.manageEarnings": [],
    "position.earningsRow": ["decision"],
    "position.earningsRowUndecided": [],
    "stat.withdrawalRate": [],
    "stat.risk": [],
    "stat.nextPayment": [],
    "activity.heading": [],
    "activity.inProgressHeading": [],
    "activity.timelineHeading": [],
    "activity.actionNeeded": [],
    "activity.today": ["date"],
    "activity.empty": [],
    "activity.error": [],
    "activity.retry": [],
    "card.bankTitle": [],
    "card.bankBody": [],
    "card.paymentDueTitle": [],
    "card.paymentDueBody": [],
    "card.pendingWithdrawalTitle": [],
    "card.pendingWithdrawalSubtitle": ["sentDate"],
    "card.pendingLiquidationTitle": [],
    "card.pendingLiquidationSubtitle": ["sentDate"],
    "card.earningsDeadlineTitle": [],
    "card.earningsDeadlineBody": [],
    "card.upcomingEarningsTitle": [],
    "card.upcomingEarningsSubtitle": ["dueDate"],
    "card.upcomingEarningsSubtitleNoDate": [],
    "card.topUpTitle": [],
    "earningsCard.title": ["month"],
    "earningsCard.titleUpcoming": [],
    "earningsCard.cadence": ["months"],
    "earningsCard.netLabel": [],
    "earningsCard.grossLabel": [],
    "earningsCard.projectedLabel": [],
    "earningsCard.covers": ["range"],
    "earningsCard.nextPayout": ["date"],
    "decision.badge": ["decision"],
    "decision.line": ["decision"],
    "decision.heading": ["decision"],
    "decision.body": ["decision", "month"],
    "decision.bodyNoMonth": ["decision"],
    "decision.footer": ["decision"],
    "decision.undecidedBadge": [],
    "decision.undecidedLine": [],
    "decision.undecidedHeading": [],
    "decision.undecidedBody": ["month"],
    "decision.undecidedBodyNoMonth": [],
    "decision.change": [],
    "decision.changeMind": [],
    "decision.choose": [],
    "info.currentValueTitle": [],
    "info.currentValueBody": [],
    "info.blendedRateTitle": [],
    "info.blendedRateBody": [],
    "breakdown.title": [],
    "breakdown.currentValue": [],
    "breakdown.assetValue": [],
    "breakdown.reserved": [],
    "breakdown.withdrawals": [],
    "breakdown.performanceHeading": [],
    "breakdown.profitLoss": [],
    "breakdown.totalEarnings": [],
    "breakdown.contributionsHeading": [],
    "breakdown.confirmedPayments": [],
    "breakdown.firstPayment": [],
    "breakdown.glossaryCta": [],
    "glossary.title": [],
    "glossary.errorTitle": [],
    "glossary.errorBody": [],
    "detail.paymentTitle": ["status"],
    "detail.investmentTitle": [],
    "detail.investmentStatus": [],
    "detail.noteInvested": [],
    "detail.withdrawalTitle": [],
    "detail.liquidationTitle": [],
    "detail.transitionTitle": ["kind"],
    "detail.rateToLabel": [],
    "detail.rowAmount": [],
    "detail.rowAmountDue": [],
    "detail.rowAmountPaid": [],
    "detail.rowRequestedAmount": [],
    "detail.rowConfirmedAmount": [],
    "detail.rowFees": [],
    "detail.rowNetAmount": [],
    "detail.rowInvested": [],
    "detail.rowNetInvested": [],
    "detail.rowDeal": [],
    "detail.rowDue": [],
    "detail.rowAcknowledged": [],
    "detail.rowReceived": [],
    "detail.rowPaidOut": [],
    "detail.rowRequested": [],
    "detail.rowSettled": [],
    "detail.rowCancelled": [],
    "detail.rowStartsEarning": [],
    "detail.rowEarningRate": [],
    "detail.rowRateNow": [],
    "detail.rowRateAfter": [],
    "detail.rowRateInNotice": [],
    "detail.rowNoticeTerm": [],
    "detail.rowNoticeEnds": [],
    "detail.status": ["status"],
    "detail.transitionStatus": ["status"],
    "detail.notePaymentDue": [],
    "detail.noteInNotice": [],
    "detail.error": [],
    "detail.makePayment": [],
    "detail.viewBankDetails": [],
    "detail.cancelPayment": [],
    "detail.cancelTransition": ["kind"],
    "detail.reallocationTitle": [],
    "detail.reallocationStatus": ["status"],
    "detail.rowFrom": [],
    "detail.rowTo": [],
    "detail.rowArrived": [],
    "detail.distributionHeading": [],
    "detail.distributionTotal": [],
    "detail.rowCovers": [],
    "detail.rowPaidOn": [],
    "detail.rowDecision": [],
    "detail.breakdownHeading": [],
    "cancelTransitionSheet.title": [],
    "cancelTransitionSheet.body": [],
    "cancelTransitionSheet.keep": [],
    "cancelTransitionSheet.cancelled": [],
    "cancelTransitionSheet.failed": [],
    "cancelPaymentSheet.title": [],
    "cancelPaymentSheet.body": [],
    "cancelPaymentSheet.keep": [],
    "cancelPaymentSheet.failed": [],
    "compare.transitionHeading": [],
    "compare.reallocationHeading": [],
    "compare.now": [],
    "compare.after": [],
    "compare.from": [],
    "compare.to": [],
    "compare.lineNotice": [],
    "compare.lineMonths": ["months"],
    "compare.lineNoNotice": [],
    "compare.lineNoticeUndecided": [],
    "compare.lineRate": [],
    "compare.lineSent": [],
    "compare.lineArrives": [],
    "compare.lineMember": [],
    "compare.delta": ["points"],
    "compare.noticeBanner": ["rate"],
    "compare.noticeBannerUntil": ["rate", "until"],
    "compare.exitBanner": ["rate"],
    "blended.title": [],
    "blended.body": [],
    "blended.depositsHeading": [],
    "blended.inNotice": [],
    "blended.rowBase": [],
    "blended.rowBoost": [],
    "blended.rowMember": [],
    "blended.rowAdjustment": [],
    "blended.legend": ["principal", "rate"],
    "blended.depositedOn": ["date"],
    "blended.guaranteed": ["rate", "date"],
    "documents.rowTitle": [],
    "documents.rowSubtitle": [],
    "documents.eisRowTitle": ["count"],
    "documents.eisRowSubtitle": [],
    "documents.title": [],
    "documents.statementTitle": [],
    "documents.statementBody": [],
    "documents.dealDocumentsHeading": [],
    "documents.dealDocumentsEmpty": [],
    "liquidationDestination.heading": [],
    "liquidationDestination.paidOut": ["account"],
    "liquidationDestination.paidOutDefault": [],
    "liquidationDestination.movedTo": ["deal"],
    "liquidationDestination.movedToIsa": ["deal"],
    "liquidationDestination.change": [],
    "liquidationDestination.title": [],
    "liquidationDestination.intro": [],
    "liquidationDestination.withdrawTitle": [],
    "liquidationDestination.withdrawTo": ["account"],
    "liquidationDestination.withdrawToDefault": [],
    "liquidationDestination.changeAccount": [],
    "liquidationDestination.dealsHeading": [],
    "liquidationDestination.dealLine": ["months"],
    "liquidationDestination.dealLineWithRate": ["rate", "months"],
    "liquidationDestination.agreement": ["deal"],
    "liquidationDestination.save": [],
    "liquidationDestination.saveError": [],
    "liquidationDestination.noAccount": [],
    "liquidationDestination.addAccount": [],
    "liquidationDestination.withdrawNoAccount": [],
    "liquidationDestination.cancel": [],
  },
};
